export default "__VITE_ASSET__qgxZvJRR__"